//TODO: При сборке добавляет все иконки в итоговый бандл. А это примерно 0.7Мб в сжатом виде. Нужно придумать другой способ импорта иконок.
//Возможно что это имеет смысл только для document-web. Нужно использовать осторожно.
import * as MUIcon from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';

type IMaterialIconProps = {
    iconName: keyof typeof MUIcon,
}

export const MaterialIcon = ({
    iconName,
    ...props
}: IMaterialIconProps & SvgIconProps) => {
    const Icon = MUIcon[iconName];

    if (!Icon)
        return null;

    return <Icon {...props} />;
}
